import { NextSeo } from 'next-seo'

import bottomImg from '@/assets/illustrations/home.svg'
import Button, { ButtonVariant } from '@/components/button'
import Link from '@/components/link'

const About = () => {
  return (
    <div className='align-center  flex h-[100%] min-h-full  flex-wrap bg-theme-turquoise px-5'>
      <NextSeo title='About' />
      <div className='py-custom pt-custom-150 mt-3 flex-[0_0_100%] '>
        <div className='mx-auto flex h-full max-w-[566px] flex-wrap content-between pl-9 pr-12'>
          <div>
            <div className='flex-no-wrap mb-7 flex h-fit w-full items-center justify-between'>
              <div>
                <Button
                  variant={ButtonVariant.Primary}
                  bg='bg-[#F59175]'
                  tailFill='#F59175'
                  className='cm-bg custom-font-body !rounded-4xl !px-2 !py-2 !font-bold text-black'
                  tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
                >
                  <span className='translate-y-0.5'>ABOUT US</span>
                </Button>
              </div>
              <div>
                <Link
                  href='/our-usp'
                  className='custom-font-body !font-bold text-black'
                >
                  OUR USP
                </Link>
              </div>
              <div>
                <Link
                  href='/team'
                  className='custom-font-body !font-bold text-black'
                >
                  TEAM
                </Link>
              </div>
            </div>
            <div className='pb-10'>
              <p className='custom-font-body mb-10'>
                All of us deal with so many emotional turmoils on a regular
                basis. Some of us use healthy coping methods, many don’t. We
                hesitate to raise our hand for professional help.
              </p>
              <p className='custom-font-body'>
                <span className='custom-font-body border-b border-black'>
                  Thrive café was created to empower everyone to take charge of
                  their own wellbeing, without the fear or hesitation to ask for
                  help.
                </span>
                {` `}To make people emotionally stronger and move them from a
                place of coping to thriving.
              </p>
            </div>
          </div>
          <div className='mb-10 w-full'>
            <img src={`${bottomImg.src}`} className='m-auto' />
          </div>
        </div>
      </div>
    </div>
  )
}
export default About
